import { useTranslation } from "react-i18next";
import bg from "../../../assets/images/icons/bg_with_logo.svg";
import global from "../../../assets/images/icons/globe.svg";
import mail from "../../../assets/images/icons/mail.svg";
import phone from "../../../assets/images/icons/phone-call.svg";
import PrivacyPolicyIcon from "../../../assets/images/icons/PrivacyPolicy.svg";
import { EndPoints } from "../../../Constants/endpoints";
import { useGetData } from "../../../hooks";
import { ManagementContactType } from "../../../interface/GeneralResponse";
import { TitleSideLink } from "../../../Share";

const AboutUs: React.FC = () => {
  const { t } = useTranslation();

  const sidebar = [
    {
      image: PrivacyPolicyIcon,
      label: "privacy_policy",
      link: "/setting/privacy_policy",
    },
    {
      image: PrivacyPolicyIcon,
      label: "terms_and_conditions",
      link: "/setting/terms_and_conditions",
    },
  ];

  const { data, isPending } = useGetData<ManagementContactType>(
    EndPoints.GetManagementContact,
  );

  const contact = [
    { name: "call_us", image: phone, link: `tel:${data?.Data?.Callus}`},
    { name: "email_us", image: mail, link: `mailto:${data?.Data?.Email}`},
    { name: "website", image: global, link: data?.Data?.Website},
  ];
  return (
    <div className="flex h-full flex-col gap-10 p-2">
      <div className="flex items-center gap-4 max-xl:flex-col">
        <img
          src={bg}
          alt="back-ground"
          className="h-60 w-full rounded-2xl object-cover xl:max-h-[300px] xl:w-3/5"
        />
        {isPending ? (
          <div className="flex flex-col justify-between gap-2 h-full">
            <div className="flex flex-col gap-2">
              <div className="h-4 w-full animate-pulse rounded-lg bg-slate-200" />
              <div className="h-4 w-3/4 animate-pulse rounded-lg bg-slate-200" />
              <div className="h-4 w-4/5 animate-pulse rounded-lg bg-slate-200" />
              <div className="h-4 w-full animate-pulse rounded-lg bg-slate-200" />
              <div className="h-4 w-3/5 animate-pulse rounded-lg bg-slate-200" />
              <div className="h-4 w-4/5 animate-pulse rounded-lg bg-slate-200" />
            </div>
            <div className="grid w-full grid-cols-3 gap-2">
              <div className="h-20 min-w-20 animate-pulse rounded-lg bg-slate-200" />
              <div className="h-20 min-w-20 animate-pulse rounded-lg bg-slate-200" />
              <div className="h-20 min-w-20 animate-pulse rounded-lg bg-slate-200" />
            </div>
          </div>
        ) : (
          <div className="flex h-full flex-col items-center justify-between gap-4 max-xl:flex-wrap xl:w-2/5">
            <p>{data?.Data?.Description}</p>
            <div className="grid w-full grid-cols-3 gap-2">
              {contact.map((e) => (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={e?.link}
                  key={e.name}
                  className={`flex flex-col items-center justify-center gap-2 rounded-lg border border-input-field bg-input-field p-4 ${e.link ? "" : "hidden"}`}
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-white">
                    <img src={e.image} alt={e.name} className="h-6 w-6" />
                  </div>
                  <p className="text-sm">{t(e.name)}</p>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2">
        {sidebar.map((e, i) => (
          <TitleSideLink key={i} label={e.label} to={e.link} icon={e.image} />
        ))}
      </div>
    </div>
  );
};

export default AboutUs;
